import React from "react";

const Event = ({ event }) => {
    return (
      <div className="text-left year-event">
        <h6 className="font-weight-bold">{event.title}</h6>
      </div>
    );
  };

export default Event